import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import axios from 'axios';
import { Map } from 'immutable';
import rootReducer from '../reducers';

export function configureStore() {
    const logger = createLogger({
        // transforms Immutable maps from reducers to the plain JS objects
        stateTransformer: state => {
            const newState = {};
            Object.keys(state).forEach(key => {
                const stateItem = state[key];
                newState[key] = Map.isMap(stateItem) ? stateItem.toJS() : stateItem;
            });

            return newState;
        }
    });

    let store = null;

    if (__PROD__) {
        const middleware = applyMiddleware(thunk);
        const enhancer = compose(
            middleware
        );
        store = createStore(rootReducer, enhancer);
    } else {
        const middleware = applyMiddleware(thunk, logger);
        /* eslint-disable no-underscore-dangle */
        const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
        /* eslint-enable */
        store = createStore(rootReducer, composeEnhancers(middleware));
    }

    return store;
}

const store = configureStore();

export const getEnvironment = () => {
    const { hostname } = window.location;

    if (hostname.includes('attuned.ai') && !hostname.startsWith('dev-') && !hostname.startsWith('staging-')) {
        return 'prod';
    } if (hostname.includes('staging')) {
        return 'staging';
    }
    return 'dev';
};

export { store };

axios.interceptors.response.use((response) => {
    return response.data;
}, (error) => {
    throw error.response.data;
});

export * from './browserUtil';
export * from './errors';
export * from './surveyUtil';
export * from './thirdParty';
